import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HiddenScrollComponent } from './hidden-scroll/hidden-scroll.component';


@NgModule({
  imports: [CommonModule],
  declarations: [
    HiddenScrollComponent
  ],
  exports: [
    HiddenScrollComponent
   ],
  providers: []
})
export class ScrollModule { }
